import { LeadInline } from "./leadgate"
import { Client, apiBase } from "./api"

const client = new Client({ baseUrl: apiBase() })

/**
 * Contact us — the ask that is not a signup.
 *
 * THE FORM MOVED to the shared kit. This is the binding: the route, the product name, and the
 * copy. It used to be a second implementation of the same four fields, which is two places for
 * the gate rule to be almost right — and the rule (zero asks before a result, exactly one after)
 * is only enforceable where there is one component to enforce it in.
 *
 * `qualified`, because this is the conversation the one-field ask is not: somebody with a
 * question who needs room to say what it is. An address with no sentence attached is a lead you
 * have to open a conversation to qualify, which at this size means you answer it three days later.
 *
 * It posts to `/leads/request-access` with `source` naming which surface it came from — the
 * closed portfolio taxonomy, so "which surface converts" stays answerable across products rather
 * than becoming a per-page string nobody can group by.
 *
 * The failure state is the kit's now, and it is still visible. This form's sibling once spent a
 * period posting to a route that did not exist, getting a 404, and falling back to a `mailto:`
 * the visitor may never have sent — silently, so nobody found out.
 */
export function Contact({
  source,
  surface,
  heading = "Talk to us",
  blurb = "A question, a use case, or something that should work and does not. We answer these ourselves.",
}: {
  source: string
  surface: string
  heading?: string
  blurb?: string
}) {
  return (
    <LeadInline
      transport={{
        submit: (body) =>
          client.post<{ unsubscribe_url?: string }>("/leads/request-access", {
            ...body,
            surface,
          }),
      }}
      product="authoxi"
      source={source}
      subject={surface}
      variant="qualified"
      trigger="page"
      copy={{
        title: heading,
        body: blurb,
        cta: "Send",
        done: "Got it — we will reply, usually the same day.",
      }}
    />
  )
}
